import Spinner from './view'

export default Spinner
